export interface BetterStackConfig { dsn: string; environment: 'production' | 'staging' | 'preview'; release: string }

export function resolveConfig(raw: unknown, version = 'unknown'): BetterStackConfig | null {
	if (!raw || typeof raw !== 'object') return null
	const { environment, dsns } = raw as { environment?: string; dsns?: Record<string, string> }
	if (!environment || !['production', 'staging', 'preview'].includes(environment)) return null
	if (typeof dsns?.[environment] !== 'string') return null
	const dsn = dsns[environment].trim()
	if (!dsn) return null
	try {
		const url = new URL(dsn)
		if (url.protocol !== 'https:' || !url.username || url.password || url.port || url.search || url.hash ||
			!/^s\d+\.[a-z0-9-]+\.betterstackdata\.com$/.test(url.hostname) || !/^\/\d+$/.test(url.pathname)) return null
		// Correlated sources use the source ID in the host and the application ID
		// in the path. Both are numeric but they need not be equal.
	} catch { return null }
	return { dsn, environment: environment as BetterStackConfig['environment'], release: `shopify-theme@${version}` }
}
